document.addEventListener("DOMContentLoaded", () => {
    document.body.classList.remove('is-transitioning');

    const links = document.querySelectorAll('a');
    links.forEach(link => {
        link.addEventListener('click', (e) => {
            const target = link.getAttribute('href');
            const targetAttr = link.getAttribute('target');
            
            if (!target || target.startsWith('#') || targetAttr === '_blank' || target.startsWith('mailto:') || target.startsWith('tel:')) {
                return; 
            }
            
            const isCurrentPageHash = target.includes('#') && target.split('#')[0] === window.location.pathname.split('/').pop();
            if(isCurrentPageHash) {
                return;
            }

            e.preventDefault();
            document.body.classList.add('is-transitioning');
            
            setTimeout(() => {
                window.location.href = target;
            }, 400); 
        });
    });
});

// Fix for Safari Back Button (bfcache)
window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
        document.body.classList.remove('is-transitioning');
    }
});
